/* Rquiere de mixin.js */

var errors = {
	data() {
		return {
		}
	},
	computed: {
	},
	filters: {
	},
	methods: {
		errorHttpHandling(error) {
			this.hideLockScreen()
			this.$snotify.error(error, 'Error')
			this.errorHttpHandlingLocal(error)
			/*let msg = (error.response.data !== undefined) ? error.response.data.message : error.response.statusText

			switch (error.response.status) {
				case 401:
					this.error401()
					break
				default:
					this.showMsgErrorHandling('Error Http!!! - (' + error.response.status + ') ' + msg)
					break
			}*/
		},
		errorHttpHandlingLocal() {

		},
		error401() {
			this.showMsgErrorHandling('No autentificado. Se cerrará la aplicación', false)
			setTimeout(() => this.goLogin(), 5000)
		},
		showMsgErrorHandling(msg, iconClose = true) {
			this.showLockScreen(msg, 'fas fa-exclamation-circle', 'text-danger', iconClose)
		}
	},
};

export default errors;